import React from 'react';
import { connect } from 'react-redux';
import DisplayLinks from '../../components/DisplayLinks';
import EditPermissionsModal from '../../components/modal/EditPermissionsModal';
import RemoveAccountModal from '../../components/modal/RemoveAccountModal';
import {openModal} from '../../actions/ModalActions';
import {Dropdown, DropdownItem} from '../bootstrap/Dropdown';
import UserAvatar from '../UserAvatar';

@connect(state => ({}))
export default class UserSidePane extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hasPermissionToEditUser : false
        };   
    }

    componentDidMount() {
        const loggedInUser = this.props.loggedInUser;
        this.setState({
            hasPermissionToEditUser : this.props.user.id === loggedInUser.id || loggedInUser.permissions.includes('CAN_ADD_DELETE_STAFF')
        });
    }

    editPermissions(){
        this.props.dispatch(openModal(EditPermissionsModal, {
            userId : this.props.user.id,
            permissions: this.props.user.permissions,
            loadActiveUser: this.props.loadActiveUser
        }));
    }

    removeAccount() {
        this.props.dispatch(openModal(RemoveAccountModal, {
            userId : this.props.user.id
        }));
    }

    render() {
        var {user} = this.props;

        return (
            <div className="fade-in">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="text-center">                     
                            <UserAvatar user={user} size={150} />
                        </div>

                        <h2 className="text-center"><strong>{user.firstName} {user.lastName}</strong></h2>
                        <h4 className="text-center">
                            <i className="fa fa-user"></i>
                            {' '}
                            {user.userRole.name}
                        </h4>
                        <h4 style={{marginTop: '15px', marginBottom: '15px'}}><strong>Contact Information</strong></h4>

                        {this.state.hasPermissionToEditUser &&
                            <Dropdown iconName="cog" className="col-xs-2">
                                <DropdownItem onClick={this.editPermissions.bind(this)}><i className="fa fa-lock"></i> Edit Permissions</DropdownItem>
                                {this.props.loggedInUser.id !== this.props.user.id &&
                                    <DropdownItem onClick={this.removeAccount.bind(this)}><i
                                        className="fa fa-trash"></i> Remove Account</DropdownItem>
                                }
                            </Dropdown>
                        }
                        

                        <ul className="profile-details">
                            <li>
                                <div className="profile-label"><i className="fa fa-phone"></i> Phone:</div>
                                <DisplayLinks className="profile-value" values={[]} type="tel" />

                            </li>
                            <li>
                                <div className="profile-label"><i className="fa fa-envelope"></i> E-mail:</div>
                                <DisplayLinks className="profile-value" values={[user.email]} type="mailto" />

                            </li>
                            <li>
                                <div className="profile-label"><i className="fa fa-map-marker"></i> Address:</div>
                                <div className="profile-value">

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/user/UserSidePane.js